import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "px-4"
}
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-sm-3 d-flex align-items-center" }
const _hoisted_4 = { class: "fw-bolder" }
const _hoisted_5 = { class: "col-sm-4" }
const _hoisted_6 = { class: "row mt-4 align-items-center" }
const _hoisted_7 = { class: "col-sm-3 d-flex align-items-center" }
const _hoisted_8 = { class: "fw-bolder me-2" }
const _hoisted_9 = { class: "col-sm-4" }
const _hoisted_10 = { class: "row mt-4 align-items-center" }
const _hoisted_11 = { class: "col-sm-3 d-flex align-items-center" }
const _hoisted_12 = { class: "fw-bolder me-2" }
const _hoisted_13 = { class: "col-sm-4" }
const _hoisted_14 = { class: "row mt-5 align-items-center" }
const _hoisted_15 = { class: "col-4" }

import RequiredWarning from "@/components/common/RequiredWarning.vue";
import { onMounted, Ref, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth";
import { postPassword, postTokenVerification } from "@/library/api/user";
import { useI18n } from "vue-i18n";
import MainFilter from "@/components/filter/MainFilter.vue";
import InputField from "@/components/common/InputField.vue";
import GreenifiedButton from "@/components/common/GreenifiedButton.vue";
import GreenifiedModal from "@/components/modal/GreenifiedModal.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterView',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();

const { t } = useI18n();

const password1 = ref("");
const password2 = ref("");
const invalidPassword = ref(false);
const showError = ref(false);
const showSuccess = ref(false);
const showTokenError = ref(false);
const isLoading = ref(true);
const name = ref("");
const passwordForm: Ref<HTMLFormElement | null> = ref(null);

const route = useRoute();

const navToLogin = () => {
  authStore.logout();
};

const verifyToken = async () => {
  isLoading.value = true;
  const result = await postTokenVerification(route.query.token as string);
  isLoading.value = false;

  if (!result.success) {
    if (result.error.status !== 410) return router.push({ name: "notFound" });
    showTokenError.value = true;
  }

  showTokenError.value = false;
};

const verifyPasswordRequirements = (firstPw: string, secondPw: string) => {
  const digitsInPassword = firstPw.replace(/\D/g, "");
  return (
    firstPw.length >= 8 &&
    firstPw === secondPw &&
    /[A-Z]/.test(firstPw) === true &&
    /[a-z]/.test(firstPw) === true &&
    digitsInPassword.length >= 2
  );
};

const postNewPassword = async () => {
  const correctPassword = verifyPasswordRequirements(
    password1.value,
    password2.value
  );

  if (!correctPassword) {
    invalidPassword.value = true;
    return;
  }

  invalidPassword.value = false;

  const result = await postPassword(
    route.query.token as string,
    password1.value,
    name.value
  );

  if (!result.success) {
    showError.value = true;
    return;
  }

  showSuccess.value = true;
};

onMounted(() => {
  verifyToken();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(LoadingOverlay, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(MainFilter, {
            "filter-title": 
        !showTokenError.value ? _unref(t)('title.register') : _unref(t)('title.urlHasExpired')
      ,
            "filter-text": 
        !showTokenError.value
          ? _unref(t)('msg.passwordRequirements')
          : _unref(t)('paragraph.urlExpiredInfo')
      ,
            hideFilterOptions: ""
          }, null, 8, ["filter-title", "filter-text"]),
          (!showTokenError.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                ref_key: "passwordForm",
                ref: passwordForm,
                id: "passwordForm",
                onSubmit: _withModifiers(postNewPassword, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("label.enterPassword") + " *"), 1),
                    (invalidPassword.value && password2.value === password1.value)
                      ? (_openBlock(), _createBlock(RequiredWarning, {
                          key: 0,
                          warningText: _unref(t)('msg.readAbovePasswordRequirements')
                        }, null, 8, ["warningText"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(InputField, {
                      type: "password",
                      "field-value": password1.value,
                      "onUpdate:fieldValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((password1).value = $event)),
                        _cache[1] || (_cache[1] = ($event: any) => (invalidPassword.value = false))
                      ],
                      placeHolder: _unref(t)('placeholders.password'),
                      required: "",
                      minlength: "8",
                      "password-has-toggle": true
                    }, null, 8, ["field-value", "placeHolder"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)("label.repeatPassword") + " *"), 1),
                    (invalidPassword.value && password2.value !== password1.value)
                      ? (_openBlock(), _createBlock(RequiredWarning, {
                          key: 0,
                          warningText: _unref(t)('msg.passwordNotTheSame')
                        }, null, 8, ["warningText"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(InputField, {
                      type: "password",
                      "field-value": password2.value,
                      "onUpdate:fieldValue": _cache[2] || (_cache[2] = ($event: any) => ((password2).value = $event)),
                      placeHolder: _unref(t)('placeholders.password'),
                      required: "",
                      "password-has-toggle": true,
                      minlength: "8"
                    }, null, 8, ["field-value", "placeHolder"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)("label.name")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(InputField, {
                      type: "text",
                      "field-value": name.value,
                      "onUpdate:fieldValue": _cache[3] || (_cache[3] = ($event: any) => ((name).value = $event)),
                      placeHolder: _unref(t)('placeholders.firstAndLastname'),
                      required: "",
                      minlength: "150"
                    }, null, 8, ["field-value", "placeHolder"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(GreenifiedButton, {
                      size: "thin",
                      type: "submit",
                      btnStyle: "black",
                      text: _unref(t)('button.register'),
                      form: 'passwordForm'
                    }, null, 8, ["text"])
                  ])
                ])
              ], 544))
            : _createCommentVNode("", true)
        ])),
    (showError.value)
      ? (_openBlock(), _createBlock(GreenifiedModal, {
          key: 2,
          type: "response",
          closable: false,
          title: _unref(t)('responseTitle.registerError'),
          text: _unref(t)('msg.registerError'),
          onClose: _cache[4] || (_cache[4] = ($event: any) => (showError.value = false))
        }, null, 8, ["title", "text"]))
      : _createCommentVNode("", true),
    (showSuccess.value)
      ? (_openBlock(), _createBlock(GreenifiedModal, {
          key: 3,
          type: "response",
          closable: false,
          title: _unref(t)('responseTitle.registerSuccess'),
          text: _unref(t)('msg.registerSuccess'),
          onClose: _cache[5] || (_cache[5] = ($event: any) => (navToLogin()))
        }, null, 8, ["title", "text"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})